import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AlvaroC_Video1 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoAlvaro1 = () => {
  return (
    <>
      <ModalVideo
        id="alvaro-video-1"
        dataText={AlvaroC_Video1}
        videoSrc="https://www.youtube.com/embed/4xXbMZffpbM?si=fBcoXuLJJkuuAg0P"
        videoTitle="KUTER_STUDIO_AI_ALVARO_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoAlvaro1;
